export const ENTRY_RESULT_RECORD_KEY = {
    /** 圖片上傳的圖片 */
    IMAGE_UPLOAD: 'imageUpload',
    /** 生成的圖片 */
    GENERATIVE_IMAGE_EXTENSION: 'generativeImageExtension',
    /** 生成的音樂 */
    GENERATIVE_AUDIO_EXTENSION: 'generativeAudioExtension',
    /** 創意相框合成完成的圖片 */
    CREATIVE_FRAME: 'creativeFrame'
};

// INFO：上傳圖片流程 Flow Key ( 目前支援圖片輯圖、相框)
export const UPLOAD_FLOW_KEY = [
    ENTRY_RESULT_RECORD_KEY.IMAGE_UPLOAD,
    ENTRY_RESULT_RECORD_KEY.CREATIVE_FRAME
];

// INFO：AI 流程 Flow Key ( 目前支援生成圖片、生成音樂)
export const AI_FLOW_KEY = [
    ENTRY_RESULT_RECORD_KEY.CREATIVE_FRAME,
    ENTRY_RESULT_RECORD_KEY.GENERATIVE_AUDIO_EXTENSION
];
